import React, { useEffect, useState, useRef, useMemo } from "react";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;
import cx from "classnames";
import TagSystem from "components/Pages/Finance/_cmpt/TagSystem";
import Countdown from "components/Pages/Finance/_cmpt/Countdown";
import Currency from "components/Pages/Finance/_cmpt/Currency";
import TagCustom from "components/Pages/Finance/_cmpt/TagCustom";
import Apy from "components/Pages/Finance/_cmpt/Apy";
import BtnSubscribe from "components/Pages/Finance/_cmpt/BtnSubscribe";
import useCountdown from "components/Pages/Finance/_hook/useCountdown";
import useProductName from "components/Pages/Finance/_hook/useProductName";
import useGetProductById from "@/components/Pages/Finance/_hook/useGetProductById";

import styles from "./index.module.less";
import stylesCard from "components/Pages/Finance/Styles/card.module.less";
import { useStore } from "@/models";
import { observer } from "mobx-react-lite";

export default observer((props) => {
  const t = useTranslation();
  const { finance } = useStore();

  const [data, setData] = useState(props.data);
  useEffect(() => {
    setData(props.data);
  }, [props.data]);

  //将data转化为组件selfData
  const selfData = useMemo(() => {
    const convertData = {
      //可选，导航标签，系统或者状态
      tagSystem: (() => {
        if (data.noviceExclusive) return { type: "green", label: t("finance.tagBeginner") };
        if (data.systemTag) return { type: "red", label: data.systemTag };
      })(),
      //币种，譬如：usdt
      currency: data.currency,
      //可选，最小认购，
      minBuy: (() => {
        if (!data.singleMin) return;
        return data.singleMin + " " + data.currency.toUpperCase();
      })(),
      //系统标签
      tagCustom: (() => {
        if (!data.customTags || !data.customTags.length) return [];
        const ary = [];
        data.customTags.map((arr) => {
          arr[0].name && ary.push(arr[0].name);
        });
        return ary;
      })(),
      //期限，譬如：365天，只有 【理财宝-活期】是活期的，其他的都有期限
      duration: (() => {
        if (data.productType === "DEMAND_SAVING") return t("finance.flexible");
        return data.duration + "D";
      })(),
    };

    return convertData;
  }, [data]);
  const destTimestamp = useCountdown(data);
  const productName = useProductName(data);

  const onFinancialProductsChange = (newFinancialProducts) => {
    for (let i in newFinancialProducts) {
      if (newFinancialProducts[i].id == data.id) setData(newFinancialProducts[i]);
    }
  };
  const btnData = useMemo(() => {
    return {
      productId: data.id,
      financialProducts: [data],
      callback: onFinancialProductsChange,
    };
  }, [data]);
  const countdownCallbackFun = useGetProductById(({ err, data }) => {
    if (err) return;
    onFinancialProductsChange([data]);
  });
  const countdownCallback = () => countdownCallbackFun(data);

  return (
    <div className={cx(stylesCard.main, styles.main)}>
      <div className={stylesCard.nav}>
        <div>{!!selfData.tagSystem && <TagSystem data={selfData.tagSystem} />}</div>
        <div>
          <Countdown key={data.id+"-"+destTimestamp} data={destTimestamp} isHideExpired callback={countdownCallback} />
        </div>
      </div>
      <div className={stylesCard.currencyCon}>
        <div>
          <Currency data={selfData.currency} className={stylesCard.currency} />
        </div>
        <div>
          {!!selfData.minBuy && (
            <div className={stylesCard.minBuy}>
              <div>{selfData.minBuy}</div>
              <span>{t("finance.minStart")}</span>
            </div>
          )}
        </div>
      </div>
      <div className={stylesCard.productCon}>
        <b>{productName}</b>
        {selfData.tagCustom.map((data) => (
          <TagCustom data={data} />
        ))}
      </div>
      <div className={stylesCard.detailCon}>
        <div>
          <div>
            <Apy className={stylesCard.apy} data={data} isCut />
          </div>
          <span>{t("finance.apy")}</span>
        </div>
        <span></span>
        <div>
          <div>
            <b>{selfData.duration}</b>
          </div>
          <span>{t("finance.duration")}</span>
        </div>
      </div>

      <div className={stylesCard.btnCon}>
        <BtnSubscribe data={btnData} />
      </div>
    </div>
  );
});
